import React from 'react'
import { Container, EvolutionReportFrame } from './styles'
export const EvolutionReport = ({ url }): JSX.Element | null => {
  if (url) {
    return (
      <Container>
        <EvolutionReportFrame src={url} />
      </Container>
    )
  }

  return null
}
